export function withSoldCounts(soldServices, deals, products, month, year) {
  if (!Array.isArray(deals) || !Array.isArray(products)) return soldServices;

  const monthKey = `${year}-${String(parseInt(month, 10)).padStart(2, "0")}`;
  const names = new Map(products.map((product) => [String(product.product_id), product.name]));
  const counts = new Map();

  deals.forEach((deal) => {
    if (String(deal.created_at || "").slice(0, 7) !== monthKey) return;
    const name = names.get(String(deal.product_id));
    if (name) counts.set(name, (counts.get(name) || 0) + 1);
  });

  return soldServices.map((service) => ({ ...service, count: counts.get(service.name) || 0 }));
}
